import { Navigate } from 'react-router-dom';

import { useCurrentSiteId } from '@hotjar/site';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { HEATMAPS } from '@hotjar/webapp/constants/routes';

export function RedirectMHRoutesToCCHeatmaps(): JSX.Element {
  const siteId = useCurrentSiteId();

  const path = !siteId
    ? '/'
    : getRoute(HEATMAPS.LIST_CONTINUOUS_CAPTURE.path, {
        siteId,
      });

  return <Navigate to={path} replace />;
}
